import { graphql } from 'gql';

export const bimWorkOrderConstructionTypesGql = graphql(`
    query bimWorkOrderConstructionTypes($workOrderId: Long!) {
        bimWorkOrderConstructionTypes(workOrderId: $workOrderId) {
            data {
                name
                id
                catalogId
                fullName
            }
        }
    }
`);

export const bimWorkOrderOtherPricesGql = graphql(`
    query bimWorkOrderOtherPrices(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
        $where: BimWorkOrderOtherPriceDataFilterInput
        $order: [BimWorkOrderOtherPriceDataSortInput!]
    ) {
        bimWorkOrderOtherPrices(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                isActKC2Price
                isExcludedRow
                hasEmptyActPlanCost
                hasEmptyActAcceptedCost
                hasActualCost
                planValue {
                    others
                    total
                    hasErrors
                    errors
                }
                completedValue {
                    others
                    total
                    hasErrors
                    errors
                }
                remainderValue {
                    others
                    total
                    hasErrors
                    errors
                }
                actKC2OtherCosts {
                    actKC2Id
                    costPlan
                    costAccepted
                    comment
                }
                completedOtherDeviation
            }
        }
    }
`);

export const bimActsKC2OtherGql = graphql(`
    query bimActsKC2Other(
        $order: [BimActKC2OtherItemDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimActKC2OtherItemDataFilterInput
        $workOrderId: Long!
        $workOrderObjectId: Long
    ) {
        bimActsKC2Other(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                id
                status
                number
                date
                correctionDate
                fullNumber
                isCorrection
                isInactive
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimIsUniqueActKC2OtherInternalNumber = graphql(`
    query bimIsUniqueActKC2OtherInternalNumber($actKC2OtherId: Long, $actKC2OtherNumber: Long!, $workOrderId: Long!) {
        bimIsUniqueActKC2OtherInternalNumber(
            actKC2OtherId: $actKC2OtherId
            actKC2OtherNumber: $actKC2OtherNumber
            workOrderId: $workOrderId
        ) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimSetActKC2OtherPlanCostGql = graphql(`
    mutation bimSetActKC2OtherPlanCost($actKC2OtherId: Long!, $cost: Decimal!, $workOrderOtherPriceId: Long!) {
        bimSetActKC2OtherPlanCost(
            actKC2OtherId: $actKC2OtherId
            cost: $cost
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimSetActKC2OtherAcceptedCostGql = graphql(`
    mutation bimSetActKC2OtherAcceptedCost($actKC2OtherId: Long!, $cost: Decimal!, $workOrderOtherPriceId: Long!) {
        bimSetActKC2OtherAcceptedCost(
            actKC2OtherId: $actKC2OtherId
            cost: $cost
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveWorkOrderOthersGql = graphql(`
    mutation bimRemoveWorkOrderOthers($workOrderId: Long!, $workOrderOtherIds: [Long!]!) {
        bimRemoveWorkOrderOthers(workOrderId: $workOrderId, workOrderOtherIds: $workOrderOtherIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveWorkOrderOtherForActGql = graphql(`
    mutation bimRemoveWorkOrderOtherForAct($workOrderObjectId: Long!, $workOrderOtherIds: [Long!]!) {
        bimRemoveWorkOrderOtherForAct(workOrderObjectId: $workOrderObjectId, workOrderOtherIds: $workOrderOtherIds) {
            data {
                itemIds
                workOrderId
                isWorkOrderChangeRequired
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderOtherDistributionGql = graphql(`
    mutation bimUpdateWorkOrderOtherDistribution(
        $workOrderOtherPriceId: Long!
        $input: BimWorkOrderOtherDistributionInput!
    ) {
        bimUpdateWorkOrderOtherDistribution(workOrderOtherPriceId: $workOrderOtherPriceId, input: $input) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderOtherGql = graphql(`
    mutation bimUpdateWorkOrderOther($workOrderOtherPriceId: Long!, $input: BimContractOtherCostUpdateInput!) {
        bimUpdateWorkOrderOther(workOrderOtherPriceId: $workOrderOtherPriceId, input: $input) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderOtherForActGql = graphql(`
    mutation bimUpdateWorkOrderOtherForAct($workOrderOtherPriceId: Long!, $input: BimContractOtherCostUpdateInput!) {
        bimUpdateWorkOrderOtherForAct(workOrderOtherPriceId: $workOrderOtherPriceId, input: $input) {
            id
            result
            message
            code
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderOtherDistributionToActKC2 = graphql(`
    mutation bimUpdateWorkOrderOtherDistributionToActKC2(
        $workOrderOtherPriceId: Long!
        $input: BimWorkOrderOtherDistributionInput!
    ) {
        bimUpdateWorkOrderOtherDistributionToActKC2(workOrderOtherPriceId: $workOrderOtherPriceId, input: $input) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimSetActKC2OtherCostCommentGql = graphql(`
    mutation bimSetActKC2OtherCostComment($actKC2OtherId: Long!, $comment: String, $workOrderOtherPriceId: Long!) {
        bimSetActKC2OtherCostComment(
            actKC2OtherId: $actKC2OtherId
            comment: $comment
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderOtherDataGql = graphql(`
    query bimWorkOrderOtherData($workOrderOtherPriceId: Long!) {
        bimWorkOrderOtherData(workOrderOtherPriceId: $workOrderOtherPriceId) {
            data {
                id
                formula
                contractId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                isGlobalOtherCost
                otherCostLimits {
                    cost
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                }
                rationale
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    canDelete
                    isSystem
                }
                catalogOtherCostTypeId
            }
        }
    }
`);

export const bimWorkOrderOtherDistributionGql = graphql(`
    query bimWorkOrderOtherDistribution($workOrderOtherPriceId: Long!) {
        bimWorkOrderOtherDistribution(workOrderOtherPriceId: $workOrderOtherPriceId) {
            data {
                contractOtherCost {
                    id
                    contractId
                    name
                    calculatingType
                    calculatingTypeValue
                    chapter
                    section
                    status
                    isGlobalOtherCost
                    formula
                }
                limit {
                    costLimit
                    totalRemainderCost
                    includedCost
                    isSystemCalculation
                }
                objectDistribution {
                    id
                    workOrderObjectId
                    name
                    isIncluded
                    cost
                    hasErrors
                    errors
                }
            }
            result
            message
            code
        }
    }
`);
